import { Check } from '@mui/icons-material'
import {
  ButtonProps,
  ListItemIcon,
  MenuItem as MuiMenuItem,
  MenuItemProps as MuiMenuItemProps,
  styled,
} from '@mui/material'
import { FC, ReactNode } from 'react'

import MenuItemText, { MenuItemTextProps } from './MenuItemText'

export interface MenuListItemProps extends MuiMenuItemProps {
  color?: ButtonProps['color']
  menuItemTextProps?: MenuItemTextProps
  primary?: ReactNode
  secondary?: ReactNode
}

const MenuListItem: FC<MenuListItemProps> = ({
  children,
  color,
  menuItemTextProps,
  primary,
  secondary,
  value,
  ...props
}) => {
  return (
    <StyledMenuItem color={color} {...props} value={value ?? props['data-value']}>
      {primary && <MenuItemText {...menuItemTextProps} primary={primary} secondary={secondary} />}
      {children}
      <ListItemIcon sx={{ minWidth: '20px !important', ml: 'auto !important' }}>
        {props.selected && <Check color={color ?? 'primary'} fontSize="small" />}
      </ListItemIcon>
    </StyledMenuItem>
  )
}

const StyledMenuItem = styled(MuiMenuItem)`
  background-color: ${({ color, theme }) => (color ? theme.palette[color].main : 'transparent')};
  gap: ${({ theme }) => theme.spacing(2)};
`

export default MenuListItem
